<template>
    <div class="wrap coop">
        <div class="main-container">
            <div class="main-visual">
                <img src="../../assets/resource/img/canter-main-visual.png" alt="이미지" class="main-visual__back">
                <div class="main-visual__con">
                    <h3 class="main-visual__title">창원파티마병원 진료협력센터</h3>
                    <p class="main-visual__text">
                        <strong> 유수한 의료기관과 협력</strong>해 <br>
                        최선의 서비스를 제공하고 있습니다 
                    </p>
                </div>
            </div>
            <div class="quick-menu main-inner">
                <div class="quick-menu__text">
                    <h3 class="quick-menu__text--title">문의 및 예약</h3>
                    <ul class="quick-menu__text--number">
                        <li><img src="../../assets/resource/icon/quick-menu__text--number01.png" alt="이미지"><a href="tel:0552701108" style="color:#fff;">055)270-1108</a></li>
                        <li><img src="../../assets/resource/icon/quick-menu__text--number02.png" alt="이미지">055)270-1029</li>
                    </ul>
                    <p>
                        평일 09:00~16:40 · 토요일 09:00~12:00 <br>
                        야간 및 응급 055)270-1119, 1120
                    </p>
                </div>
                <ul class="quick-menu__list">
                    <li class="quick-menu__item">
                        <a href="javascript:;">
                            <img src="../../assets/resource/icon/canter-quick-menu-icon01.png" alt="이미지">
                            <h4>센터소개</h4>
                        </a>
                    </li>
                    <li class="quick-menu__item">
                        <a href="javascript:;">
                            <img src="../../assets/resource/icon/canter-quick-menu-icon04.png" alt="이미지">
                            <h4>의료진 검색</h4>
                        </a>
                    </li>
                    <li class="quick-menu__item">
                        <a href="javascript:;">
                            <img src="../../assets/resource/icon/canter-quick-menu-icon05.png" alt="이미지">
                            <h4>협력 병/의원 현황</h4>
                        </a>
                    </li>
                    <li class="quick-menu__item">
                        <a href="javascript:;">
                            <img src="../../assets/resource/icon/canter-quick-menu-icon02.png" alt="이미지">
                            <h4>협력병원 체결 절차</h4>
                        </a>
                    </li>
                    <li class="quick-menu__item">
                        <a href="javascript:;">
                            <img src="../../assets/resource/icon/canter-quick-menu-icon03.png" alt="이미지">
                            <h4>협력병원 체결 절차</h4>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="form-download main-inner">
                <a href="javascript:;">
                    <p>협력병원신청서 양식 다운로드</p>
                </a>
                <a href="javascript:;">
                    <p>진료의뢰신청서 양식 다운로드</p>
                </a>
            </div>
            <div class="canter-board">
                <div class="canter-board__title main-inner">
                    <h3>파티마뉴스</h3>
                    <a href="javascript:;">
                        <p>더보기</p>
                    </a>
                </div>
                <div class="canter-board__list">
                    <div class="canter-board__header">
                        <ul class="canter-board__tr main-inner">
                            <li>NO.</li>
                            <li>제목</li>
                            <li>등록일</li>
                            <li></li>
                        </ul>
                    </div>
                    <ul class="canter-board__body">
                        <li class="canter-board__item">
                            <ul class="canter-board__tr main-inner">
                                <li>
                                    공지
                                </li>
                                <li>
                                    <a href="javascript:;">제목입니다.</a>
                                </li>
                                <li>2024-03-18</li>
                                <li><a href="javascript:;" class="plus"></a></li>
                            </ul>
                        </li>
                        <li class="canter-board__item">
                            <ul class="canter-board__tr main-inner">
                                <li>
                                    10
                                </li>
                                <li>
                                    <a href="javascript:;">제목입니다.</a>
                                </li>
                                <li>2024-03-18</li>
                                <li><a href="javascript:;" class="plus"></a></li>
                            </ul>
                        </li>
                        <li class="canter-board__item">
                            <ul class="canter-board__tr main-inner">
                                <li>
                                    9
                                </li>
                                <li>
                                    <a href="javascript:;">제목입니다 제목입니다 제목입니다 제목입니다 제목입니다 제목입니다 제목입니다.</a>
                                </li>
                                <li>2024-03-18</li>
                                <li><a href="javascript:;" class="plus"></a></li>
                            </ul>
                        </li>
                        <li class="canter-board__item">
                            <ul class="canter-board__tr main-inner">
                                <li>
                                    8
                                </li>
                                <li>
                                    <a href="javascript:;">제목입니다.</a>
                                </li>
                                <li>2024-03-18</li>
                                <li><a href="javascript:;" class="plus"></a></li>
                            </ul>
                        </li>
                        <li class="canter-board__item">
                            <ul class="canter-board__tr main-inner">
                                <li>
                                    7
                                </li>
                                <li>
                                    <a href="javascript:;">제목입니다.</a>
                                </li>
                                <li>2024-03-18</li>
                                <li><a href="javascript:;" class="plus"></a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // import gsap from 'gsap'
    import 'swiper/css';
    import 'swiper/css/effect-creative';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';
    import { Navigation, Autoplay, Pagination, EffectCreative } from 'swiper/modules';
    // import { gsap, ScrollTrigger, Draggable, MotionPathPlugin, Power1 } from "gsap/all";


    export default {
        components: {
        },
        data() {
        },
        setup() {
        },
        methods: {
        },
        mounted() {
            
        }
    }
</script>


